<!-- 校友资源页面点击校友懒加载调转至校友资源详情页面 -->
<template>
  <div>
    <!-- 校友资源详情 -->
    <div class="alumniDetailsDiv">
      <div class="alumniDetails">
        <div class="alumniPhotoDiv">
          <img :src="this.alumnus.url" alt="" class="alumniPhoto" />
          <div class="sexDiv">
            <img src="../../assets/image/btn_nan_nor.png" alt="男" v-if="this.alumnus.sex == 1" class="sexImage" />
            <img src="../../assets/image/btn_nv_nor.png" alt="女" class="sexImage" v-else />
          </div>
          <div class="adress">{{ this.alumnus.city }}</div>
        </div>
        <div class="alumniData">
          <div class="alumniNameAndBtn">
            <div class="alumniName">{{ this.alumnus.name }}</div>
            <button class="exchange" v-if="this.alumnus.status == null" @click="changeCard">
              交换名片
            </button>
            <button class="exchange" v-else-if="
              this.alumnus.status == '待回复'
            " @click="refuseShow">
              拒绝TA
            </button>
            <button class="exchange" v-else-if="
              this.alumnus.status == '已申请'
            ">
              等待确认
            </button>
            <button class="exchange" v-else-if="this.alumnus.status == '已同意'">
              交换完成
            </button>
          </div>
          <div class="alumniCard">
            <div class="schoolAndGraduation">
              {{ this.alumnus.school }} &nbsp;&nbsp;
              {{ this.alumnus.dissertation }}
            </div>
            <div class="industry">从事行业：{{ this.alumnus.hangye }}</div>
            <div class="company">单位：{{ this.alumnus.danwei }}</div>
            <div class="phone" v-if="this.alumnus.isOpen == 0">
              微信/电话：用户暂未公开
            </div>
            <div class="phone" v-else-if="
              this.alumnus.isOpen == 1 && this.alumnus.status !== '已同意'
            ">
              微信/电话：交换名片可见
            </div>
            <div class="phone" v-else-if="this.alumnus.isOpen == 1">
              微信/电话：{{ this.alumnus.phone }}
            </div>
          </div>
        </div>
      </div>
      <div class="alumniCardImgDiv">
        <img src="../../assets/image/btn_yuan_nor.png" class="alumniCardImg" alt="" />
      </div>
      <div class="provideResourcesDiv">
        提供资源：
        <div class="provideResources" v-if="this.alumnus.industry == null">
          <div class="none">无</div>
        </div>
        <div class="provideResources clearfix" v-else>
          <div class="provideResourcesName" v-for="item in alumnus.industryArray" :key="item.id">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="resourcesExplainDiv">
        资源说明：
        <div class="resourcesExplain" v-if="this.alumnus.industryNotice == null">
          <div class="none">无</div>
        </div>
        <div class="resourcesExplain" v-else>
          {{ this.alumnus.industryNotice }}
        </div>
      </div>
      <div class="needResourcesDiv">
        需求资源：
        <div class="needResources" v-if="alumnus.need == null">
          <div class="none">无</div>
        </div>
        <div class="needResources clearfix" v-else>
          <div class="needResourcesName" v-for="item in alumnus.needArray" :key="item.id">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="resourcesExplainDiv">
        资源说明：
        <div class="resourcesExplain" v-if="alumnus.needNotice == null">
          <div class="none">无</div>
        </div>
        <div class="resourcesExplain" v-else>
          {{ this.alumnus.needNotice }}
        </div>
      </div>
      <div class="hobbyDiv">
        兴趣爱好：
        <div class="hobby" v-if="alumnus.hobby == null">
          <div class="none">无</div>
        </div>
        <div class="hobby clearfix" v-else>
          <div class="hobbyName">
            {{ alumnus.hobby }}
          </div>
        </div>
        <!--  <img
          src="../../assets/image/btn_xiaoyuan_nor.png"
          alt=""
          class="hobbyImg"
        /> -->
        <div class="argeeChangeBtnDiv" v-if="
        this.alumnus.status == '待回复'">
          <button class="argeeChangeBtn" @click="argeeChange">同意交换</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Base64 from "@/utils/base64";

export default {
  data() {
    return {
      alumnus: "",
      myCard: "",
      localStorageUser: window.localStorage.getItem("user_id"),
      userId: this.$route.query.alumniId,
      is_read: this.$route.query.is_read,
    };
  },
  created() {
    this.getAlumnus();
    this.getMyCard();
  },
  methods: {
    async getAlumnus() {
      let base64 = new Base64()
      if (this.is_read !== undefined) {
        const result = await this.$http.get("/myFriend/getCardInfo", {
          params: {
            myId: base64.encode(this.localStorageUser),
            otherId: base64.encode(this.userId),
            mesId: this.$route.query.mid
          }
        });
        this.alumnus = result.data.info;
      } else {
        const result = await this.$http.get("/myFriend/getCardInfo", {
          params: {
            myId:  base64.encode(this.localStorageUser),
            otherId:  base64.encode(this.userId),
          }
        });
        this.alumnus = result.data.info;
      }
    },
    async getMyCard() {
      const result = await this.$http.get("/myBusinessCard/getBusinessCard", {
        params: {
          userId: this.localStorageUser,
        },
      });
      this.myCard = result.data.detailInfo;
    },
    async changeCard() {
      if (this.myCard.isOpen === 0) {
        this.$toast("请先公开您的名片，个人中心-我的名片-公开名片");
      } else {
        const result = await this.$http({
          url: "/myFriend/applyExchange",
          method: "POST",
          data: {
            // 申请时候userId是本用户，拒绝和同意时pushId是本用户
            pushId: parseInt(this.userId),
            userId: parseInt(this.localStorageUser)
          },
        });
        if (result.data.msg !== "已申请") {
          this.$toast(result.data.msg);
        } else {
          this.$toast("交换名片成功，等待对方确认");
          location.reload();
        }
      }
    },
    refuseShow() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "您确认要拒绝交换名片吗？",
        })
        .then(() => {
          this.refuse();
        })
        .catch(() => {
          // on cancel
        });
    },
    async refuse() {
      const result = await this.$http({
        url: "/myFriend/acceptExchange",
        method: "POST",
        headers: { "Content-Type": 'application/json' },
        data: {
          // 申请时候userId是本用户，拒绝和同意时pushId是本用户
          userId: parseInt(this.userId),
          pushId: window.localStorage.getItem("user_id"),
          status: 2,
        },
      });
      if (result.data.msg == "已拒绝") {
        this.$toast("拒绝成功");
        location.reload();
      } else {
        this.$toast(result.data.msg);
      }
    },
    async argeeChange() {
      const result = await this.$http({
        url: "/myFriend/acceptExchange",
        method: "POST",
        headers: { "Content-Type": 'application/json' },
        data: {
          // 申请时候userId是本用户，拒绝和同意时pushId是本用户
          userId: parseInt(this.userId),
          pushId: window.localStorage.getItem("user_id"),
          status: 1,
        },
      });
      if (result.data.msg == "已同意") {
        this.$toast("交换成功");
        location.reload();
      } else {
        this.$toast(result.data.msg);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.alumniDetailsDiv {
  margin-top: 20px;
  position: relative;
  left: 5%;
  width: 90vw;
  background-color: white;
  border-radius: 15px;
  box-shadow: 2px 3px 8px 0px rgba(3, 29, 19, 0.29);
}

.alumniDetails {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.alumniPhotoDiv {
  position: relative;
  width: 25%;
  padding: 10px 0px 0px 10px;
}

.alumniPhoto {
  width: 100%;
  height: 22.5vw;
  border-radius: 999px;
}

.sexDiv {
  width: 20px;
  position: absolute;
  left: 80%;
  top: 10px;
}

.sexImage {
  width: 100%;
}

.adress {
  padding-top: 5px;
  text-align: center;
  font-size: 1.2em;
  color: #00706E;
  font-weight: bold;
}

.alumniData {
  padding-left: 15px;
  width: 66%;
}

.alumniNameAndBtn {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.alumniName {
  font-size: 1.3em;
  font-weight: bold;
}

.exchange {
  font-size: 1.1em;
  border: 0;
  border-radius: 20px;
  color: #ffffff;
  padding: 5px 10px 5px 10px;
  background-image: linear-gradient(to left, #00706E, #00706E);
}

.schoolAndGraduation {
  font-size: 1.1em;
  color: #666666;
  padding-top: 5px;
}

.industry {
  font-size: 1.1em;
  color: #666666;
  padding-top: 5px;
}

.company {
  font-size: 1.1em;
  color: #666666;
  padding-top: 5px;
}

.phone {
  font-size: 1.1em;
  color: #666666;
  padding-top: 5px;
  padding-bottom: 20px;
}

.alumniCardImgDiv {
  position: absolute;
  top: 10%;
  right: 0%;
  width: 30%;
}

.alumniCardImg {
  width: 100%;
  height: 100%;
}

.provideResourcesDiv {
  font-size: 1.3em;
  font-weight: bold;
  padding: 0 10px;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.provideResourcesName {
  float: left;
  font-size: 0.9em;
  border-width: 1.5px 1.5px 1.5px 1.5px;
  border-style: solid;
  border-color: #00706E;
  border-radius: 15px;
  padding: 3px 8px 3px 8px;
  color: #00706E;
  margin-right: 10px;
  margin-top: 15px;
}

.resourcesExplainDiv {
  margin-top: 20px;
  font-size: 1.3em;
  font-weight: bold;
  padding: 0 10px;
}

.resourcesExplain {
  padding-top: 10px;
  padding-right: 10px;
  font-size: 1rem;
  color: #333333;
  font-weight: normal;
  line-height: 1.5rem;
}

.needResourcesDiv {
  margin-top: 20px;
  font-size: 1.3em;
  font-weight: bold;
  padding: 0 10px;
}

.needResourcesName {
  float: left;
  font-size: 0.9em;
  border-width: 1.5px 1.5px 1.5px 1.5px;
  border-style: solid;
  border-color: #00706E;
  border-radius: 15px;
  padding: 3px 8px 3px 8px;
  color: #00706E;
  margin-right: 10px;
  margin-top: 15px;
}

.hobbyDiv {
  margin: 20px 0;
  font-size: 1.3em;
  font-weight: bold;
  padding: 0 10px;
  position: relative;
  min-height: 23vh;
  background-image: url(../../assets/image/btn_xiaoyuan_nor.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.hobbyName {
  float: left;
  font-size: 0.9em;
  border-width: 1.5px 1.5px 1.5px 1.5px;
  border-style: solid;
  border-color: #00706E;
  border-radius: 15px;
  padding: 3px 8px 3px 8px;
  color: #00706E;
  margin-right: 10px;
  margin-top: 15px;
}

.hobbyImg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
}

.none {
  font-size: 1rem;
  font-weight: normal;
  padding-top: 10px;
}

.argeeChangeBtnDiv {
  margin: 20px 0;
  width: 100%;
}

.argeeChangeBtn {
  border: 0;
  background: linear-gradient(270deg, #00706E, #00706E);
  color: white;
  width: 100%;
  border-radius: 30px;
  padding: 10px 0;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/alumniResources/AlumniDetails.vue